import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'weekDayPipe',
})
export class WeekDayPipe implements PipeTransform {
  transform(dayOfWeek: string) {
    return ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'][dayOfWeek];
  }
}
